<template>
	<v-container fluid>
		<v-row>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
					single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="'لیست پرداخت های شما به نماینده'">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="items"
					:footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search"
					class="elevation-1">
					<template v-slot:item.saveDate_Persian="{ item }">
						{{ item.saveDate_Persian.date }} {{ item.saveDate_Persian.time }}
					</template>
					<template v-slot:item.amount="{ item }">
						{{ item.amount.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.userLoan.amount="{ item }">
						{{ item.userLoan.amount.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.userLoan.subAgentPrice="{ item }">
						{{ item.userLoan.subAgentPrice.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.successfullOnlineMoneyTransferId="{ item }">
						<v-icon color="success" v-if="!!item.successfullOnlineMoneyTransferId" title="دارای تراکنش آنلاین"
							small>mdi-credit-card-check-outline</v-icon>
					</template>
					<template v-slot:item.operations="{ item }">
						<td class="text-center">
							<v-btn class="mx-1" fab dark x-small color="secondary" @click="editTransaction(item)">
								<v-icon dark>
									mdi-square-edit-outline
								</v-icon>
							</v-btn>
							<v-btn class="mx-1" fab dark x-small color="pink" @click="removeTransaction(item)">
								<v-icon dark small>
									mdi-trash-can-outline
								</v-icon>
							</v-btn>
						</td>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<confirm-dlg ref="confirm" />
		<v-dialog v-model="dialogTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifySubAgentTransaction v-if="dialogTransaction" :data="selectedTransaction"
							@callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'SubAgentTransactions',
		props: {
			agent: { type: Object },
			userLoan: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifySubAgentTransaction: () => import('./ModifySubAgentTransaction'),
		},
		data() {
			return {
				selectedTransaction: null,
				dialogTransaction: false,
				errorMessages: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'تاریخ واریز',
						align: 'center',
						sortable: true,
						value: 'saveDate_Persian',
					}, {
						text: 'مبلغ تراکنش',
						align: 'start',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'مبلغ وام',
						align: 'start',
						sortable: true,
						value: 'userLoan.amount',
					},
					{
						text: 'سهم نماینده',
						align: 'start',
						sortable: true,
						value: 'userLoan.subAgentPrice',
					},
					{
						text: 'توضیحات',
						align: 'start',
						sortable: true,
						value: 'description',
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						value: 'operations',
						width: 130
					}
				],
				items: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('agent/SubAgentTransaction/List/' + this.agent.id + (this.userLoan ? '/' + this.userLoan.id : ''), null)
					.then(response => {
						this.items = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			async removeTransaction(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('agent/subAgentTransaction/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
								this.$emit('update')
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			editTransaction(item) {
				this.selectedTransaction = item
				this.dialogTransaction = true
			},
			callbck_transaction(result) {
				this.dialogTransaction = false
				if (result) {
					this.loadData()
					this.$emit('update')
				}
			},
		},
	}
</script>
<style></style>
